export var STATIC_DEV_URL = 'http://localhost:3010/';
export var STATIC_TEST_URL = 'https://assets.animatron-test.com/static/';
export var STATIC_PROD_URL = 'https://assets.animatron.com/static/';